import { useState } from 'react';

const productTypes = [
  {
    id: 'custom-coffee-bags',
    label: 'Custom Coffee Bags',
    icon: 'ri-cup-line',
    title: 'Özel Kahve Poşetleri',
    subtitle: 'Custom Coffee Bags',
    description:
      'Tek orjinli filtre kahveden espresso çekirdeklerine, kahve dükkanınızın ve markanızın özgün sesini yansıtan poşet etiketleri üretiyoruz. Kraft dokusuyla hazırlanmış, aromayı bozmayan gıda güvenli kaplamalar ve özel form kesim seçenekleri sunuyoruz.',
    features: ['Aroma koruyucu gıda güvenli kaplama', 'Kraft ve mat laminasyon seçeneği', 'Özel form ve boşluk kesimi', 'Tek yönlü CO₂ valf uyumlu yapı'],
    image: 'https://public.readdy.ai/ai/img_res/206bb2918168908d287a38ada398f730.jpg',
    color: '#8B5E3C',
    bg: 'from-amber-50 to-orange-50',
  },
  {
    id: 'leksan-etiket',
    label: 'Leksan Etiket',
    icon: 'ri-drop-line',
    title: 'Leksan Etiket',
    subtitle: 'Leke & Kimyasal Dirençli',
    description:
      'Polikarbonat leksan malzeme, yüzeyde oluşan sürtünme, yağ ve agresif temizlik kimyasallarına karşı olağanüstü bir bariyer oluşturur. Makine yağlama noktaları, deterjan şişeleri ve endüstriyel ekipman etiketlemesinde tercih edilen çözüm.',
    features: ['Yağ ve su geçirmez polimer yapı', 'Asit bazlı solventlere direnç', 'Sert yüzey aşınma koruması', 'Ekstrem sıcaklık ve UV dayanımı'],
    image: 'https://readdy.ai/api/search-image?query=industrial%20chemical%20resistant%20labels%20closeup%20on%20cleaning%20product%20containers%20and%20spray%20bottles%20showing%20bold%20safety%20text%20and%20hazard%20symbols%20on%20plain%20concrete%20workshop%20background%20with%20dramatic%20side%20lighting&width=700&height=500&seq=pt-leksan-v2-302&orientation=landscape',
    color: '#2D7D46',
    bg: 'from-green-50 to-teal-50',
  },
  {
    id: 'food-packaging',
    label: 'Food Packaging',
    icon: 'ri-restaurant-line',
    title: 'Gıda Ambalaj Etiketleri',
    subtitle: 'Food Packaging',
    description:
      'Türk Gıda Kodeksi ve AB 1169/2011 tüzüğüne tam uyumlu etiket tasarım ve üretimi yapıyoruz. Alerjen uyarı kutusu, beslenme değeri tablosu, barkod ve QR kod entegrasyonu dahil, bütünleşik bir gıda etiketi çözümü sunuyoruz.',
    features: ['TSE ve FDA malzeme sertifikası', 'Dondurucu zinciri yapışkanı', 'GS1 barkod ve QR kod entegrasyonu', 'Alerjen uyarı standardı uyumu'],
    image: 'https://readdy.ai/api/search-image?query=organic%20supermarket%20shelf%20with%20neatly%20arranged%20food%20products%20showing%20colorful%20printed%20labels%20with%20nutrition%20facts%20and%20ingredient%20lists%20on%20glass%20and%20plastic%20packaging%20natural%20grocery%20store%20lighting%20healthy%20food%20product%20photography&width=700&height=500&seq=pt-food-v2-303&orientation=landscape',
    color: '#E67E22',
    bg: 'from-orange-50 to-yellow-50',
  },
  {
    id: 'damla-etiket',
    label: 'Damla Etiket',
    icon: 'ri-water-flash-line',
    title: 'Damla Etiket',
    subtitle: '3D Reçine Kaplama',
    description:
      'Polietilen ve epoksi reçine karışımından oluşan damla kaplama, etiketin üzerine şeffaf ve parlak bir kubbe oluşturur. Bu yöntemle elde edilen 3D derinlik hissi, elektronik cihazlar, promosyon ürünleri ve otomotiv aksesuarları için tercih edilen premium sonuç.',
    features: ['Epoksi kubbe ile 3D derinlik efekti', 'Çizilme ve darbe koruması', 'Uzun dönem UV renk kalıcılığı', 'Lüks dokunuş ve algı kalitesi'],
    image: 'https://readdy.ai/api/search-image?query=macro%20photography%20of%20transparent%20dome%20epoxy%20resin%20label%20on%20black%20electronic%20gadget%20showing%20glossy%20bubble%20effect%20with%20vivid%20color%20underneath%20selective%20focus%20on%20raised%20label%20surface%20dark%20moody%20background%20premium%20product%20detail%20shot&width=700&height=500&seq=pt-damla-v2-304&orientation=landscape',
    color: '#1A6B9A',
    bg: 'from-sky-50 to-cyan-50',
  },
  {
    id: 'lazer-etiket',
    label: 'Lazer Etiket',
    icon: 'ri-focus-3-line',
    title: 'Lazer Etiket',
    subtitle: 'Lazer Kesim & Baskı',
    description:
      'CO₂ ve fiber lazer sistemlerimizle mikron hassasiyetinde kesim ve gravür işlemi yapıyoruz. Sahtecilik önleyici hologram tabakası, seri numaralı baskı ve güvenlik yarım kesim (kiss-cut) özellikleriyle yüksek değerli ürünleri koruma altına alıyoruz.',
    features: ['CO₂ lazer ile mikron hassasiyeti', 'Güvenlik hologram baskısı', 'Benzersiz seri numarası sistemi', 'Kiss-cut ve tam kesim alternatifleri'],
    image: 'https://readdy.ai/api/search-image?query=precision%20laser%20engraving%20machine%20cutting%20intricate%20pattern%20on%20metallic%20label%20sheet%20showing%20fine%20detail%20and%20sparks%20with%20dark%20workshop%20background%20technical%20industrial%20laser%20cutting%20process%20close%20up&width=700&height=500&seq=pt-lazer-v2-305&orientation=landscape',
    color: '#7B2FBE',
    bg: 'from-violet-50 to-purple-50',
  },
  {
    id: 'stock-packaging',
    label: 'Stock Packaging',
    icon: 'ri-archive-line',
    title: 'Stok Ambalaj Etiketleri',
    subtitle: 'Hazır & Hızlı Teslimat',
    description:
      'Girişimciler ve butik üreticiler için minimum sipariş baskısı olmadan etiket almanın en pratik yolu. Standart ölçü arşivimizden seçim yapın, tasarımınızı gönderin; 24 saat içinde elinizde olsun. Kargo dahil fiyatlandırma seçeneği.',
    features: ['Sıfır minimum sipariş kısıtı', '24 saatte üretim ve kargo', 'Stok ölçü kataloğundan seçim', 'Kargo dahil fiyatlandırma'],
    image: 'https://readdy.ai/api/search-image?query=organized%20label%20storage%20room%20with%20rows%20of%20label%20rolls%20in%20various%20sizes%20on%20metal%20shelving%20system%20bright%20overhead%20lighting%20showing%20inventory%20management%20in%20professional%20printing%20facility%20neat%20and%20orderly%20warehouse&width=700&height=500&seq=pt-stock-v2-306&orientation=landscape',
    color: '#C0392B',
    bg: 'from-red-50 to-rose-50',
  },
  {
    id: 'paslanmaz-etiket',
    label: 'Paslanmaz Etiket',
    icon: 'ri-shield-check-line',
    title: 'Paslanmaz Çelik Etiket',
    subtitle: 'Metal & Dayanıklı',
    description:
      '0.3 mm - 1 mm kalınlık aralığında paslanmaz çelik ve alüminyum üzerine lazer gravür ya da UV baskı uyguluyoruz. Makine tanımlama plakaları, tesis numaraları ve dış mekan yön işaretleri gibi kalıcı kullanım alanları için tercih edilen çözüm.',
    features: ['316L paslanmaz çelik ve alüminyum', 'Dış mekana uygun hava dayanımı', 'Fiber lazer gravür seçeneği', 'Vidalı ve yapıştırmalı montaj'],
    image: 'https://readdy.ai/api/search-image?query=brushed%20stainless%20steel%20nameplate%20with%20laser%20engraved%20serial%20number%20and%20company%20logo%20mounted%20on%20gray%20industrial%20machine%20surface%20showing%20clean%20professional%20metal%20label%20with%20bolted%20corners%20workshop%20background&width=700&height=500&seq=pt-metal-v2-307&orientation=landscape',
    color: '#5D6D7E',
    bg: 'from-slate-50 to-gray-50',
  },
  {
    id: 'rulo-etiket',
    label: 'Rulo Etiket',
    icon: 'ri-loop-right-line',
    title: 'Rulo Etiket',
    subtitle: 'Termal & Dijital Rulo',
    description:
      'Zebra, Datamax ve Honeywell termal transfer yazıcılarla tam uyumlu rulo etiket üretiyoruz. İç çap, yönlendirme ve boşluk ayarları fabrika kalibrasyonuyla yapılmış; hat üzerine takın, üretmeye başlayın.',
    features: ['Zebra ve Datamax tam uyumu', 'Direkt termal ve transfer seçeneği', 'Önceden kalibre edilmiş boşluk', 'Her boyut ve adezif grubu'],
    image: 'https://readdy.ai/api/search-image?query=white%20thermal%20label%20rolls%20on%20dispenser%20next%20to%20barcode%20printer%20in%20logistics%20warehouse%20showing%20inventory%20barcode%20stickers%20with%20QR%20codes%20on%20cardboard%20boxes%20conveyor%20belt%20background%20e-commerce%20fulfillment%20center&width=700&height=500&seq=pt-rulo-v2-308&orientation=landscape',
    color: '#1A7A4A',
    bg: 'from-emerald-50 to-green-50',
  },
];

export default function ProductTypes() {
  const [active, setActive] = useState(productTypes[0].id);

  const current = productTypes.find((p) => p.id === active)!;

  return (
    <section id="product-types" className="py-24 bg-[#FAFAF8]">
      <div className="max-w-7xl mx-auto px-6">
        {/* Başlık */}
        <div className="text-center mb-14">
          <span className="text-sm font-semibold tracking-widest text-[#FF6B35] uppercase">
            Ürün Tipleri
          </span>
          <h2 className="text-4xl lg:text-5xl font-bold text-[#1A2332] mt-3 leading-tight">
            Her İhtiyaca Özel
            <span className="italic text-[#FF6B35]"> Etiket Çözümü</span>
          </h2>
          <p className="text-base text-gray-500 mt-4 max-w-xl mx-auto">
            Sektörünüze ve ürününüze en uygun etiket tipini seçin, detaylı bilgi alın.
          </p>
        </div>

        {/* Sekme Butonları */}
        <div className="flex flex-wrap justify-center gap-2 mb-12">
          {productTypes.map((pt) => (
            <button
              key={pt.id}
              onClick={() => setActive(pt.id)}
              className={`flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium transition-all duration-300 whitespace-nowrap cursor-pointer border ${
                active === pt.id
                  ? 'bg-[#1A2332] text-white border-[#1A2332] shadow-lg scale-105'
                  : 'bg-white text-gray-600 border-gray-200 hover:border-[#FF6B35] hover:text-[#FF6B35]'
              }`}
            >
              <span className="w-5 h-5 flex items-center justify-center">
                <i className={`${pt.icon} text-base`}></i>
              </span>
              {pt.label}
            </button>
          ))}
        </div>

        {/* İçerik Paneli */}
        <div
          key={active}
          className={`bg-gradient-to-br ${current.bg} rounded-3xl overflow-hidden shadow-xl border border-white`}
          style={{ animation: 'fadeInUp 0.35s ease' }}
        >
          <div className="grid lg:grid-cols-2 gap-0">
            {/* Sol: Bilgi */}
            <div className="p-10 lg:p-14 flex flex-col justify-center">
              <div
                className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full text-xs font-semibold mb-6 w-fit"
                style={{ backgroundColor: current.color + '18', color: current.color }}
              >
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className={`${current.icon} text-sm`}></i>
                </span>
                {current.subtitle}
              </div>

              <h3 className="text-3xl lg:text-4xl font-bold text-[#1A2332] mb-4 leading-tight">
                {current.title}
              </h3>
              <p className="text-base text-gray-600 leading-relaxed mb-8">
                {current.description}
              </p>

              {/* Özellikler */}
              <ul className="space-y-3 mb-10">
                {current.features.map((f, i) => (
                  <li key={i} className="flex items-center gap-3 text-sm text-gray-700">
                    <span
                      className="w-6 h-6 rounded-full flex items-center justify-center flex-shrink-0"
                      style={{ backgroundColor: current.color + '20' }}
                    >
                      <i className="ri-check-line text-xs font-bold" style={{ color: current.color }}></i>
                    </span>
                    {f}
                  </li>
                ))}
              </ul>

              <div className="flex gap-3">
                <a
                  href="#contact"
                  className="inline-flex items-center gap-2 px-6 py-3 rounded-full text-sm font-semibold text-white transition-all duration-300 hover:opacity-90 whitespace-nowrap cursor-pointer"
                  style={{ backgroundColor: current.color }}
                >
                  Teklif Al
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-right-line text-sm"></i>
                  </span>
                </a>
                <a
                  href="#contact"
                  className="inline-flex items-center gap-2 px-6 py-3 rounded-full text-sm font-semibold border-2 transition-all duration-300 hover:bg-white whitespace-nowrap cursor-pointer"
                  style={{ borderColor: current.color, color: current.color }}
                >
                  Detaylı Bilgi
                </a>
              </div>
            </div>

            {/* Sağ: Görsel */}
            <div className="relative h-72 lg:h-auto min-h-[320px] overflow-hidden">
              <img
                src={current.image}
                alt={`${current.title} - Bioetiket profesyonel etiket baskı`}
                className="w-full h-full object-cover object-top"
                loading="eager"
                decoding="async"
                width="700"
                height="500"
                style={{ aspectRatio: '700/500' }}
              />
              <div className="absolute inset-0 bg-gradient-to-r from-white/10 to-transparent"></div>
            </div>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(16px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </section>
  );
}